/* global axios */

import ApiClient from './ApiClient';

class SicSupportAPI extends ApiClient {
  constructor() {
    super('sic_support', { accountScoped: true });
  }

  chat({ message, images = [], history = [] }) {
    return axios.post(`${this.url}/chat`, { message, images, history });
  }

  syncKnowledge() {
    return axios.post(`${this.url}/sync_knowledge`);
  }

  check() {
    return axios.get(`${this.url}/check`);
  }

  listFiles() {
    return axios.get(`${this.url}/files`);
  }

  getFile(fileKey) {
    return axios.get(`${this.url}/files/${fileKey}`);
  }

  saveFile(fileKey, content) {
    return axios.put(`${this.url}/files/${fileKey}`, { content });
  }
}

export default new SicSupportAPI();
